import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';

export class MyStorage implements Storage {
  removeItem(key: string): void {
    if (this[key]) {
      delete this[key];
      this.length--;
    }
  }
  setItem(key: string, value: string): void {
    if (!this[key]) {
      this.length++;
    }
    this[key] = value
  }
  [name: string]: any;

  length = 0;

  clear() {
    Object.keys(this).forEach(key => {
      delete this[key];
    })
    this.length = 0;
  };
  getItem(key: string) {
    return this[key] ?? null;
  };

  key(index: number) {
    const keys = Object.keys(this);
    let i = 0;
    for (let key of keys)
      if (i == index)
        return key;

    return null;
  };
}

declare type StorageType = 'localStorage' | 'sessionStorage'

@Injectable({
  providedIn: 'root'
})
export class BrowserStorageService {

  localStorage: Storage;
  sessionStorage: Storage;

  constructor(@Inject(PLATFORM_ID) private platformid: any) {
    if (isPlatformBrowser(this.platformid)) {
      this.localStorage = localStorage;
      this.sessionStorage = sessionStorage;
    } else {
      this.localStorage = new MyStorage();
      this.sessionStorage = new MyStorage();
    }

  }

  public saveData(key: string, value: string, StorageType: StorageType) {
   this[StorageType].setItem(key, value);
  }

  public getData(key: string, StorageType: StorageType) {
    return this[StorageType].getItem(key)
  }
  public removeData(key: string, StorageType: StorageType) {
    this[StorageType].removeItem(key);
  }

  public clearData(StorageType: StorageType) {
    this[StorageType].clear();
  }
}
